var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxShoeSneakers = function Svg18PxShoeSneakers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.838 10.75h11.379M1.25 9.065l3.283.72c.609.135 1.12.548 1.382 1.114L7 13.249M11.038 5.619l-.803 1.286"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.911 4.106C8.407 5.419 7.185 6.25 5.694 6.25A3.49 3.49 0 0 1 2.434 4H2.25a1 1 0 0 0-1 1v6.25a2 2 0 0 0 2 2h11.875a2.124 2.124 0 0 0 1.163-3.901L8.045 3.488"
  })));
};
export default Svg18PxShoeSneakers;